{
  "en": {
    "reminder": {
      "actions": {
        "cancel": "Cancel",
        "edit": "Edit",
        "hideReminders": "Hide reminders",
        "save": "Save",
        "showReminders": "Show reminders"
      },
      "contactType": {
        "customer": "Customer",
        "partner": "Partner"
      },
      "labels": {
        "after": "after",
        "before": "before",
        "click": "Click here to set reminder",
        "date": "on {date}",
        "dateAfterDueDate": "After due date",
        "dateAlreadyPassed": "date has already passed",
        "decisionApprovedNotSent": "The Decision has been decided. Reminders that were still in the queue are cancelled.",
        "dueDate": "the due date",
        "editTitle": "Edit reminders",
        "here": "here",
        "infoReminders": "Reminders are only active for installments with a deadline set.",
        "noReminderSet": "No reminder set",
        "reminder": "Reminder",
        "reminders": "Reminders",
        "remindersCustomer": "Reminders for your customer",
        "remindersPartners": "Reminders for the partner(s)",
        "sendOnDeadline": "Reminder will be sent on due date",
        "sendReminder": "Send reminder",
        "sent_at": "Reminder sent at {date}",
        "warningReminders": "This action replaces all 4 reminders. Any reminder left blank here will be removed for every decision."
      },
      "toasts": {
        "update": "Reminder successfully updated"
      }
    }
  }
}
